import React, { useState, } from 'react';
import {
  makeStyles,
  Grid,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import {
  Header,
  ConcludeButtonContainer,
} from './styles';
import { update } from '../../../../../services/modalities.service';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "1vh 1vw"
  },
  button: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    minWidth: 180,
    minHeight: 50,
    borderRadius: 25,
  },
  buttonOutlined: {
    border: "2px solid",
    fontSize: "1rem",
    fontWeight: "bold",
    color: theme.palette.grey.main,
    textTransform: "capitalize",
    minWidth: 180,
    borderRadius: 25,
    minHeight: 50,
  },
  spacer: {
    marginBottom: 20
  },
  success: {
    backgroundColor: theme.palette.success.dark,
    borderRadius: 5,
    height: 50
  },
  label: {
    ...theme.typography.subtitle1,
    color: theme.palette.primary.contrastText
  },
  icon: {
    color: theme.palette.primary.contrastText,
    fontSize: 30,
    marginRight: 50
  },
  titleModal: {
    color: '#031795',
    fontWeight: 'bold',
    fontSize: '20px'
  },
}));

const UpdateModalityModal = ({
  onSuccess,
  setModalStatus,
  modality,
  t,
  onError,
}) => {
  const classes = useStyles();

  const [modalityName, setModalityName] = useState(modality.name);
  const [enabled, setEnabled] = useState(modality.enabledBoolean);

  const handleUpdateModality = async () => {
    const updatedModality = {
      name: modalityName,
      enabled,
    };

    const { error, message } = await update(modality.id, updatedModality);

    if (error) {
      onError(message.response.data.message);
      setModalStatus(false);

      return;
    };

    onSuccess();
    setModalStatus(false);
  };

  return (
    <>
      <div >
        <Header>
          <div>
            <span
              style={{ float: 'right', cursor: 'pointer' }}
              onClick={() => { setModalStatus(false) }}
            >
              [X] Fechar
            </span>

            <span className={classes.titleModal}>{t("menu.modalities.link.updateModality")}</span>
          </div>
        </Header>

        <Grid container spacing={3}>
          <Grid item lg={6} xs={6}>
            <TextField
              name="modalityName"
              id="modalityName"
              onChange={(e) => setModalityName(e.target.value)}
              value={modalityName}
              label={t("slots.modality")}
              fullWidth
              required
              autoComplete="nope"
              error={modalityName ? false : true}
            />
          </Grid>

          <Grid item lg={6} xs={6}>
            <FormControlLabel
              fullWidth
              control={
                <Checkbox
                  value={enabled}
                  checked={enabled}
                  onChange={() => setEnabled(!enabled)}
                  color="primary"
                />
              }
              label={t("menu.modalities.link.enabled")}
            />
          </Grid>
        </Grid>

        <ConcludeButtonContainer>
          <Button
            className={classes.buttonOutlined}
            variant="outlined"
            onClick={() => setModalStatus(false)}
          >
            {t("forms.committee.buttons.cancel")}
          </Button>
          <Button
            className={classes.button}
            variant="contained"
            onClick={handleUpdateModality}
          >
            {t("forms.committee.buttons.save")}
          </Button>
        </ConcludeButtonContainer>
      </div>
    </>
  )
}

export default UpdateModalityModal;
